import { defineComponent, reactive, Transition, KeepAlive } from "vue";
import styles from "./Layout.module.less";
import Sider from "./Sider/Sider";
import Content from "./Content/Content";
import { useStore as useTagsStore } from "@/store/tags";
export default defineComponent({
  setup(props: any, { slots }) {
    const tagsStore = useTagsStore();
    const state = reactive({
      isCollapsed: false,
    })
    return () => (
      <div class={styles.layout}>
        <Sider isCollapsed={state.isCollapsed} />
        <Content v-model:isCollapsed={state.isCollapsed}>
          <router-view>
            {
              ({ Component, route }: { Component: any, route: any }) => {
                return (
                  <Transition name="fade-transform" mode="out-in">
                    <KeepAlive include={tagsStore.cachedViews}>
                      {Component && <Component key={route.name + (tagsStore?.tags?.find(x => x.name === route.name)?.key ?? '')} />}
                    </KeepAlive>
                  </Transition>
                )
              }
            }
          </router-view>
        </Content>
      </div>
    )
  }
})